export const Exchanges_data = [
    {
        "id": 101,
        "name": "IEX"
    },
    {
        "id": 102,
        "name": "HPX"
    },
    {
        "id": 103,
        "name": "PXIL"
    }];